export const ComponentErrors = {
    DuplicateComponent: 'Component can only be used once',
    InvalidComponent: 'Invalid component',
    BackupGiftArrayRequired: 'Back up gift array is required when using smart gift arrays.',
    InvalidCampaign: 'This component requires a campaign with a giving goal or total gift goal.'
};
